import React, {lazy, Suspense, useContext, useMemo, useEffect, useCallback} from "react";
import StickyArea from "../../containers/StickyArea";
import SelectionsOverview from "../SelectionsOverview/SelectionsOverview";
import AppContext, {INTRO_MOVIE_FINISHED} from "../../store";
import {closeFullscreen} from '../../helpers/index';
import classNames from "classnames";
import PropTypes from 'prop-types';
import './styles/ConfiguratorHolder.scss';
import {
	DEVICE_SIZE_SMALL,
} from '../../contants/media';
import useScreenOrientationExtended from "../../hooks/useScreenOrientationExtended";
import useDeviceSizeDetect from "../../hooks/useDeviceSizeDetect";
import {TabsNavigation, ConfiguratorNextStepButton} from "./ConfiguratorsPanel";
import {webRTCObserver, EVENT_VIDEO_FINISHED} from "./hooks/useConfiguratorMount";
import {useHover} from "../../hooks/useHover";
import CartOverview from '../CartOverview/CartOverview';
import Media from 'react-media';
const LazyConfiguratorsPanel = lazy(() => import('./ConfiguratorsPanel'));

const closeFullScreenStyles = {top: '20px', right: '20px'};

export default function ConfiguratorHolder(props) {
	const {
		bundles,
		options,
		activeBundleId,
		isStickyPanelCollapsed,
		streamStore,
		toggleStickyPanel,
	} = useContext(AppContext);
	const {isPortrait} = useScreenOrientationExtended();
	const detectMobile = useDeviceSizeDetect();

	const isLoaded = useMemo(() => {
		return bundles.length && options.length
	}, [bundles, options])
	
	const isMobilePortraitOrDesktop = useMemo(() => {
		return ((detectMobile.isMobile && isPortrait) || detectMobile.isDesktop)
	}, [detectMobile, isPortrait]);

	const openStickyPanel = useCallback(() => {
		if(isStickyPanelCollapsed) {
			toggleStickyPanel(!isStickyPanelCollapsed)
		}
	}, [
		toggleStickyPanel,
		isStickyPanelCollapsed,
	]);
	
	useEffect(() => {
		/* Calls once */
		if(streamStore[INTRO_MOVIE_FINISHED]) {
			openStickyPanel()
			webRTCObserver.publish(EVENT_VIDEO_FINISHED)
		}
	}, [streamStore[INTRO_MOVIE_FINISHED]])
	
	/*@TODO IPhone issue | Always returns false on IPhone*/
	// const isMobileLandscape = useMemo(() => {
	// 	return detectMobile.isMobile() && isLandscape
	// }, [detectMobile, isLandscape]);

	return (
		<div
			className={classNames("configurator-holder", {
				'collapsed': isStickyPanelCollapsed,
				'loaded': props.isLoaded,
			})}
		>
			
			{
				isMobilePortraitOrDesktop
				&& <Media
					query={DEVICE_SIZE_SMALL}
					render={()=> (
						<CartOverview/>
					)}
				/>
			}
			
			
			<div ref={props.sizeContainerRef} className="stream-size-container">
				<div ref={props.containerRef} className="stream-container">
					<video ref={props.videoRef} />
					<audio ref={props.audioRef} /> {/*Audio functionality*/}
					<i
						onClick={closeFullscreen}
						className="icon-close close-fullscreen"
						style={closeFullScreenStyles}>&nbsp;
					</i>
				</div>
				{props.children}
			</div>
			
			{
				isLoaded &&
				<>
					<StickyArea>
						<Suspense fallback={false}>
							<LazyConfiguratorsPanel/>
						</Suspense>
						<CartOverview/>
					</StickyArea>

					{/*@TODO Should be removed from the DOM: if device big */}
					<div className={'mobile-landscape-navigation visible-device-small'}>
						<TabsNavigation />
						<ConfiguratorNextStepButton />
					</div>
				</>
			}
			
			{activeBundleId && <SelectionsOverview/>}
		</div>
	)
}

ConfiguratorHolder.propTypes = {
	isLoaded: PropTypes.bool,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	sizeContainerRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	]),
	containerRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	]),
	videoRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	]),
	audioRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	]),
}
